import { SDKService } from "./service";
import type { SDKOptions, SDKRequestOptions, SDKResponseOptions } from "./type";

// SDK核心实现
export abstract class SDKCore extends SDKService {
  // 系统参数
  public get options(): SDKOptions | null {
    return this.state.options as SDKOptions | null;
  }
  // 系统参数
  public set options(options: SDKOptions | null) {
    this.state.options = options;
    if (!this.debug) return;
    console.warn(
      [
        "调试信息：",
        `游戏ID：nbAppId=${this.options?.config.nbAppId ?? ""}`,
        `渠道ID：nbChannelId=${this.options?.config.nbChannelId ?? ""}`,
        `渠道模板标识：nbChannelTemplateCode=${this.options?.config.nbChannelTemplateCode ?? ""}`,
        `通行证标识：passportCode=${this.options?.config.passportCode ?? ""}`,
        `支付标识：paymentCode=${this.options?.config.paymentCode ?? ""}`,
        "参数不存在请重新下载配置文件：星云开放平台 → 游戏中心 → 选择游戏 → 对接中心 → 渠道打包 → 渠道配置",
      ].join("\n"),
    );
  }

  // 聚合网关请求
  public async requestGateway<T>(args: SDKRequestOptions): Promise<SDKResponseOptions<T>> {
    args.url = `${import.meta.env.VITE_GATEWAY_API}${args.url}`;
    return await this.request<T>(args);
  }

  // 通行证请求
  public async requestPassport<T>(args: SDKRequestOptions): Promise<SDKResponseOptions<T>> {
    args.url = `${import.meta.env.VITE_PASSPORT_API}${args.url}`;
    return await this.request<T>(args);
  }

  // 聚合服务请求
  public async requestCombine<T>(args: SDKRequestOptions): Promise<SDKResponseOptions<T>> {
    args.url = `${import.meta.env.VITE_COMBINE_API}${args.url}`;
    return await this.request<T>(args);
  }

  // 客服请求
  public async requestService<T>(args: SDKRequestOptions): Promise<SDKResponseOptions<T>> {
    args.url = `${import.meta.env.VITE_SERVICE_API}${args.url}`;
    return await this.request<T>(args);
  }

  // 日志上报请求
  public async requestTrack<T>(args: SDKRequestOptions): Promise<SDKResponseOptions<T>> {
    args.url = `${import.meta.env.VITE_SLSLOG_API}${args.url}`;
    return await this.request<T>(args);
  }
}
